export enum ActionType {
	Open,
	Close,
	Accept,
	Reject,
	Select,
	Create,
	Edit,
	Update,
	Ignore,
	Delete,
	Destroy,
	Save,
	Add,
	Confirm,
	Print,
	Preview,
	Next,
	Previous,
	Duplicate,
	Send,
	Download,
	Upload,
	Block,
	Unblock,
	Toggle,
	Sort,
	Filter,
	Search,
	Cancel,
	Submit,
	Validate,
	SetPageNumber,
	SetPageSize,
	Reset,
	Export,
	MassAffect,
	Affect,
	OpenRapportGlobalAPR,
	Disaffect,
	Flag,
	Unflag,
	RecalculAPR,
	Refresh,
	MassDelete,
	Soumettre
}

export enum TypeModification {
	creation = 'creation',
	affectation = 'affectation',
	modfification = 'modfification'
}
